import { getInitialState, updateState } from "@/utils/helpers/StoreUtil";
import DataProvider from "@/utils/helpers/DataProvider";

import { IVuexState } from "@/models/interfaces/store";
import { AxiosError } from "axios";

import { State as RootState } from "@/store";
import { ActionTree, MutationTree, Module } from "vuex";
import {
  IKnowledgeBase,
  IKnowledgeBaseDetail
} from "@/models/interfaces/knowledge-base";

export interface State {
  knowledgeBase: IVuexState<IKnowledgeBase[]>;
  knowledgeBaseDetail: IVuexState<any>;
}

export const actions: ActionTree<State, RootState> = {
  async fetchKnowledgeBase({ commit }) {
    commit("setKnowledgeBase");

    return DataProvider.get<{ data: IKnowledgeBase[] }>("knowledgeBase")
      .then(response => {
        commit("setKnowledgeBase", response.data.data);
        return response.data.data;
      })
      .catch((error: AxiosError) => {
        commit("setKnowledgeBase", error);
        return error;
      });
  },

  async fetchKnowledgeBaseDetail({ commit }, id: string) {
    commit("setKnowledgeBaseDetail");

    return DataProvider.get<{ data: IKnowledgeBaseDetail }>(
      `knowledgeBase/${id}`
    )
      .then(response => {
        commit("setKnowledgeBaseDetail", response.data.data);
        return response.data.data;
      })
      .catch((error: AxiosError) => {
        commit("setKnowledgeBaseDetail", error);
        return error;
      });
  }
};

export const mutations: MutationTree<State> = {
  setKnowledgeBase(state, data?: Array<IKnowledgeBase[]> | AxiosError) {
    state.knowledgeBase = updateState(state.knowledgeBase, data);
  },
  setKnowledgeBaseDetail(
    state,
    data?: Array<IKnowledgeBaseDetail> | AxiosError
  ) {
    state.knowledgeBaseDetail = updateState(state.knowledgeBaseDetail, data);
  }
};

const store: Module<State, RootState> = {
  namespaced: true,
  state: {
    knowledgeBase: getInitialState(),
    knowledgeBaseDetail: getInitialState()
  },
  mutations,
  actions
};

export default store;
